import { BackendService } from './BackendService';

export default class PencilService {
  static async createPencil(dealId: string, pencil: any) {
    const result = await BackendService.post<any>(`/pencils/${dealId}`, pencil);
    return result.data;
  }

  static async updatePencil(pencilId: string, pencil: any) {
    const result = await BackendService.put(`/pencils/${pencilId}`, pencil);
    return result.data;
  }
}
